import React, { useState } from "react";
import { Menu, X, LogOut } from "lucide-react";

import NoticeSection from "./NoticeSection";
import EmployeeSection from "./EmployeeSection";
import PublicationSection from "./PublicationSection";
import CopyrightSection from "./CopyrightSection";
import PatentSection from "./PatentSection";
import QuerySection from "./QuerySection";
import SportsSection from "./SportsSection";
import CulturalSection from "./CulturalSection";

const PrincipalDashboard = () => {
  const [activeSection, setActiveSection] = useState("notice");
  const [isOpen, setIsOpen] = useState(false);

  const handleSectionClick = (section) => {
    setActiveSection(section);
    setIsOpen(false); // Close sidebar on mobile after click
  };

  const handleLogout = () => {
    // Remove token if stored
    localStorage.removeItem("principalToken");

    // Redirect to login page
    window.location.href = "/principal-login";
  };

  return (
    <div className="flex min-h-screen bg-gray-100">

      {/* Mobile Top Navbar */}
      <div className="md:hidden flex items-center justify-between bg-[#112E65] text-white p-4 fixed top-0 w-full z-50">
        <h2 className="text-lg font-bold">Principal Panel</h2>
        <button onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Sidebar */}
      <aside
        className={`fixed md:static top-0 left-0 h-full w-64 bg-[#112E65] text-white p-6 transform transition-transform duration-300 z-40
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
        md:translate-x-0`}
      >
        <h2 className="text-2xl font-bold mb-10 hidden md:block">
          Principal Panel
        </h2>

        <ul className="space-y-5 mt-16 md:mt-0">

          <li
            onClick={() => handleSectionClick("notice")}
            className="cursor-pointer hover:text-gray-300"
          >
            Add Notice
          </li>

          <li
            onClick={() => handleSectionClick("employee")}
            className="cursor-pointer hover:text-gray-300"
          >
            Faculty Account Creation
          </li>

          <li
            onClick={() => handleSectionClick("publication")}
            className="cursor-pointer hover:text-gray-300"
          >
            Publications
          </li>

          <li
            onClick={() => handleSectionClick("copyright")}
            className="cursor-pointer hover:text-gray-300"
          >
            Copyright
          </li>
          <li
            onClick={() => handleSectionClick("sports")}
            className="cursor-pointer hover:text-gray-300"
          >
            Sports
          </li>
          <li
            onClick={() => handleSectionClick("cultural")}
            className="cursor-pointer hover:text-gray-300"
          >
            Cultural
          </li>

          <li
            onClick={() => handleSectionClick("patent")}
            className="cursor-pointer hover:text-gray-300"
          >
            Patent
          </li>
          <li
            onClick={() => handleSectionClick("query")}
            className="cursor-pointer hover:text-gray-300"
          >
            Queries
          </li>

          {/* Logout Button */}
          <li
            onClick={handleLogout}
            className="cursor-pointer flex items-center gap-2 text-red-300 hover:text-red-500 mt-10"
          >
            <LogOut size={18} />
            Logout
          </li>

        </ul>
      </aside>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 md:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}

      {/* Main Content */}
      <main className="flex-1 p-6 md:p-10 mt-16 md:mt-0">

        {activeSection === "notice" && <NoticeSection />}
        {activeSection === "cultural" && <CulturalSection />}
        {activeSection === "sports" && <SportsSection />}
        {activeSection === "employee" && <EmployeeSection />}
        {activeSection === "publication" && <PublicationSection />}
        {activeSection === "copyright" && <CopyrightSection />}
        {activeSection === "patent" && <PatentSection />}
        {activeSection === "query" && <QuerySection />}


      </main>
    </div>
  );
};

export default PrincipalDashboard;